import React, { useCallback } from 'react';
import { FormFeedback } from 'reactstrap';
import { Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import DatePicker from 'react-datepicker';
import { DateTime } from 'luxon';

import 'react-datepicker/dist/react-datepicker.css';

const DateInput = ({
  name, control, disabled, errors, minDate,
}) => {
  errors = errors || [];

  const extractDate = useCallback((date, onChange) => {
    onChange(DateTime.fromJSDate(date).toFormat('yyyy-MM-dd'));
  }, []);

  const getValue = useCallback((value) => {
    if (!value) return undefined;

    return DateTime.fromFormat(value, 'yyyy-MM-dd').toJSDate();
  }, []);

  const handleDateChangeRaw = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <Controller
        control={control}
        name={name}
        render={({ field: { name, onChange, value }, fieldState: { invalid } }) => (
          <DatePicker
            name={name}
            selected={getValue(value)}
            onChange={(date) => extractDate(date, onChange)}
            invalid={invalid}
            className={`form-control ${invalid && 'is-invalid'}`}
            disabled={disabled}
            dateFormat="yyyy-MM-dd"
            autoComplete="off"
            onChangeRaw={handleDateChangeRaw}
            minDate={minDate}
          />
        )}
      />
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => <FormFeedback className="d-block">{message}</FormFeedback>}
      />
    </>
  );
};

export default DateInput;
